var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#pattern);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #0096d2;\r\n        font-size: 12px;\r\n        font-family: Lato-Medium, Lato;\r\n        font-weight: 500;\r\n        letter-spacing: 0.03em;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 69"
  }, /*#__PURE__*/React.createElement("image", {
    width: 100,
    height: 69,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABFCAYAAAC8EkPHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABGZJREFUeNrsnE1IFGEYx98d0jSVNlKMwsokVov8ABVMKBXsIhlRhlFeNoKiLh3yJhjdPHXo49QSRCB1CK0IElwLzFBBk8SMSssQzY/sQ7F1nW2focl3xkF9Z2Zn35mevwgrwzzuzG+fb0cXCSv7eF2IOECejDSSlBhv2/fvq6txCQTFlRAIAkGtpHVOu6D6sxVkcuYX6Xn3hfQMjpC5+QB6iBElJcSR0oIsXecmuxNIWuomkudJI97DRWTzxgTF8Q1xsdIxBMIA43a9l1yrPUkqS/KYz6dv9uT3WTIy/k0Bo7amnFysOkiKczIQyFpheHZukX6+euEoyd+bzmTjQN7uf68hXNECjwHvkV/zCkXgEQaoua2HdPcPrdnG1hS34vzBT+OK400v+hT5hFcoAq8w6m48ZLJDexPceLWHQPhquNvCPRTBCTBAZYWZS+EqXGFpyQ5QBCfAUFdmau+wExSBFxiDw2Ok4c5TXfbUZfJKQHiHIvAC40y9j/ycnddlUxGuVoHBOxTB7jCkhL4nfdX8YRcogt1hQLgC26wewisUwc4wtMKVntkVT1AEO8NQJ3R1M8gK5fqD58u6e6uhCHaGAc0gHa5evRkyZA+A+h51RBVKRIGcryqNGAwpXBVkKmyPfp0xbLP99QdNKMnuRGd4CC2YTZkFQwpXhUvhqincVJolyEUwLaYVvz7G/kCg0aMBnKoo0jVW1xJ4HgwUZfk7B0yxK4/pk6ldSnvfR8Uo37ZAAIY6RMFY3QwoRygboxMz0rdZMOQxvQzD1/zSOVWWVt4wAwo93TXDO3iAYVkfYjYU9e7DaP7gBYalnbqZUOhkDqEKbBsRrHV5gGEpEBoKLYBCf9pZ84fRcOWt3E88O1IVDWK0YFgORIai3nmom0eWcNXVP2wIRnH2rmUjlGgqKvsQ9SJKq6NfSzKH8OfvGjAVRrT/jitqG0O9UOhhotNgRBWIHijqVW1r51vm31l9KJ9bGFEHshIU9dhFqq5Uq1pWD4EhYTnlYQCBJxhcAJGh3HvSsSoUI+EKYMCQkGcY3AABwdyrmWrwIGxBSaxI6NSqliVcQY+hBcOq+ZQtgYAgdMlQoIK6dd+vCFe0x7B4CNz4lr8AeYYB4u5xBIAC3XdruOGjO3B1uGId4zc+65YgfB6b5hYGl0BAtGdoJXS9zSAsn3iXbR7YOXH5pjTDKguDMWv3gUAMCMIYVGJ0NeZE4TOGCASFQBAICoEgEFTEyt7T3mOOuJiF4G8SEkX7A9mevs0RQKamp0kgELD1NWDIQiAoBIJAUAjESWUvl58UFyGu8BeLYmPYn+EIBoNE5KhUdvEK5PH7KdhSlbCcExBDJLDI/P88S6uzUtowZKEQCAJBIRAEgkIgCASFQP5XWdYYNg5M+Bk79dxwp+5mOWcu+IMshBaY3teiGOwNEZHlIffeczn7LkXqPlk5OmHqukWp4WbrugFGUGReUOViyEIhEASCQiBOkJVJ/YpD7tlwJI3/EWAABPaQHGZLw9gAAAAASUVORK5CYII="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Developers",
    transform: "translate(-2896 -139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Developers-2",
    "data-name": "Developers",
    className: "cls-1",
    width: 51,
    height: 35,
    transform: "translate(2901 139)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Developers-3",
    "data-name": "Developers",
    className: "cls-2",
    transform: "translate(2928 197)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.641,
    y: 0
  }, "Developers")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.4df60a8f00b3fdd3a5040b077d119f9b.svg";
export { ForwardRef as ReactComponent };